// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f735f7f4","60":"2e9c21b1","118":"f855a679","368":"cdaede6d","509":"565a26dc","697":"411bc2ea"}[chunkId] + ".chunk.js";
};